import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { EsqueletoPortada } from './Esqueleto';
import Slider from './Slider';
import CustomAd from './CustomAd';
import Popup from './Popup';
import SliderNotas from './SliderNotas';
import { supabase } from "../client/client";
import NewspaperLayout from './NewspaperLayout';
import NewspaperLayoutInv from './NewspaperLayoutInv';

const Home = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [newsData, setNewsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);

  const [adsNumber1, setAdsNumber1] = useState([]);
  const [adsNumber2, setAdsNumber2] = useState([]);

  const [newsCategory1, setNewsCategory1] = useState([]);
  const [newsCategory2, setNewsCategory2] = useState([]);
  const [newsCategory3, setNewsCategory3] = useState([]);
  const [newsCategory4, setNewsCategory4] = useState([]);
  const [newsCategory5, setNewsCategory5] = useState([]);

  useEffect(() => {
    const fetchNewsAndCategories = async () => {
      const { data: news, error: newsError } = await supabase
        .from('news')
        .select('*')
        .in('number', [1, 2, 3]);

      if (newsError) {
        console.error('Error fetching news:', newsError);
        return;
      }

      const { data: categories, error: categoriesError } = await supabase
        .from('categorias')
        .select('*');

      if (categoriesError) {
        console.error('Error fetching categories:', categoriesError);
        return;
      }

      setNewsData(news);
      setCategoriesData(categories);

      setNewsCategory1(news.filter(n => n.category_id === 1));
      setNewsCategory2(news.filter(n => n.category_id === 2));
      setNewsCategory3(news.filter(n => n.category_id === 3));
      setNewsCategory4(news.filter(n => n.category_id === 4));
      setNewsCategory5(news.filter(n => n.category_id === 5));
    };

    
const fetchPublicityData = async () => {
  const { data: publicity, error: publicityError } = await supabase
    .from('publicity')
    .select('*');

  if (publicityError) {
    console.error('Error fetching publicity:', publicityError);
    return;
  }

  const anunciosValidos = (publicity || []).filter((ad) => {
    const enlace = (ad.enlace || '').trim();

    return !/spotify/i.test(enlace) && Boolean(ad.image_url);
  });

  setAdsNumber1(anunciosValidos.filter(ad => ad.number === 1));
  setAdsNumber2(anunciosValidos.filter(ad => ad.number === 2));
};


    fetchNewsAndCategories();
    fetchPublicityData();
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  const formatearFecha = (valor) => {
    if (!valor) return '';
    return new Date(valor).toLocaleDateString('es-PE', {
      day: 'numeric', month: 'long', year: 'numeric',
    });
  };

  const porFecha = (a, b) =>
    new Date(b.fecha_publicacion || b.updated_at || b.created_at) - new Date(a.fecha_publicacion || a.updated_at || a.created_at);

  // Pieza destacada: la noticia principal mas reciente de todo el sitio.
  const recientes = [...newsData].sort(porFecha);
  const destacada = recientes.find((n) => n.number === 1) || recientes[0];
  const ultimas = recientes.filter((n) => !destacada || n.id !== destacada.id).slice(0, 5);
  const categoriaDe = (id) => categoriesData.find((c) => c.id === id);

  return (
    <>
      {showPopup && <Popup closePopup={closePopup} />}

      <div className="class_home">
        <div className="ad-container">
          <div className="custom-ad-wrapper">
            {adsNumber1.length > 0 && (
              <CustomAd ads={adsNumber1} interval={5000} />
            )}
          </div>
        </div>

        <div className="w-[100%]">
          {newsData.length === 0 && <EsqueletoPortada />}

          {destacada && (
            <div className="ed-shell ed-hero">
              <div className="ed-grid">
                <div>
                  <Link to={`/noticias/${destacada.id}`} className="news-card-link">
                    <figure className="ed-hero__figure">
                      <img src={destacada.image_url} alt={destacada.title} />
                    </figure>
                    <div style={{ textAlign: 'center' }}>
                      <span className="ed-hero__tag">
                        {categoriaDe(destacada.category_id)?.name || 'Destacado'}
                      </span>
                    </div>
                    <h1 className="ed-hero__title">{destacada.title}</h1>
                  </Link>
                  <p className="ed-byline ed-hero__byline">
                    <strong>{destacada.written_by}</strong>
                    {destacada.written_by ? ' | ' : ''}
                    {formatearFecha(destacada.fecha_publicacion || destacada.updated_at || destacada.created_at)}
                  </p>
                </div>

                <aside className="ed-aside">
                  <h2 className="ed-section-head">Últimas noticias</h2>
                  <ul className="ed-list">
                    {ultimas.map((n) => (
                      <li key={n.id} className="ed-list__item">
                        <Link to={`/noticias/${n.id}`}>
                          <img src={n.image_url} alt="" loading="lazy" decoding="async" />
                        </Link>
                        <div>
                          <Link to={`/noticias/${n.id}`}>
                            <h3 className="ed-list__title">{n.title}</h3>
                          </Link>
                          <p className="ed-list__date">
                            {formatearFecha(n.fecha_publicacion || n.updated_at || n.created_at)}
                          </p>
                        </div>
                      </li>
                    ))}
                  </ul>
                </aside>
              </div>
            </div>
          )}

          <div className='slider_notas'>
            <SliderNotas newsData={newsData} categoriesData={categoriesData} />
          </div>

          <div className="newspaper-layout">
            <NewspaperLayout    newsData={newsCategory1} categoriesData={categoriesData} />
            <NewspaperLayoutInv newsData={newsCategory2} categoriesData={categoriesData} />
            <NewspaperLayout    newsData={newsCategory3} categoriesData={categoriesData} />
            <NewspaperLayoutInv newsData={newsCategory4} categoriesData={categoriesData} />
            <NewspaperLayout    newsData={newsCategory5} categoriesData={categoriesData} />

            <div className="ad-container">
              <div className="custom-ad-wrapper">
                {adsNumber2.length > 0 && (
                  <CustomAd ads={adsNumber2} interval={5000} />
                )}
              </div>
            </div>

            <h1 className='title'>Revista CÁMARA AQP</h1>
            <a
              href="https://www.camara-arequipa.org.pe/revista/"
              target='_blank'
              rel='noopener noreferrer'
            >
              <div className='button_revista'>Ver todas las revistas</div>
            </a>
          </div>

          <Slider />
        </div>
      </div>
    </>
  );
};

export default Home;
